export default {
  SET_RECORDING: (state, recording) => (state.recording = recording),

  SET_IS_LOADING_RECORDING: (state, isLoadingRecording) =>
    (state.isLoadingRecording = isLoadingRecording),

  SET_RECORDING_OWNER: (state, recordingOwner) =>
    (state.recordingOwner = recordingOwner)
};
